import {
  DiceConfig,
  FakirConfig,
  FlipCardsConfig,
  GameConfigs,
  MysteryBoxesConfig,
  ScratchCardConfig,
  SlotMachineConfig
} from "kadow-jetpack-model";
import { tt } from "../utils/i18n/i18n";

const DEFAULT_SM_CONFIG: SlotMachineConfig = {
  winRate: 1,
  coinsToPlay: 1
};

const DEFAULT_FW_CONFIG: SlotMachineConfig = {
  winRate: 1,
  coinsToPlay: 1
};

const DEFAULT_SC_CONFIG: ScratchCardConfig = {
  coinsToPlay: 1.0,
  winRate: 1.0,
  image: "637fb0c0b97c6b42b387985e.jpg",
  height: "840",
  width: "883"
};

const DEFAULT_DICE_CONFIG: DiceConfig = {
  coinsToPlay: 1.0,
  winRate: 1.0,
  colors: {
    floor: "",
    grid: ""
  }
};

const DEFAULT_FLIPCARDS_CONFIG: FlipCardsConfig = {
  coinsToPlay: 1,
  winRate: 1
};

const DEFAULT_FAKIR_CONFIG: FakirConfig = {
  winRate: 1,
  coinsToPlay: 1
};

const DEFAULT_MYSTERY_BOXES_CONFIG: MysteryBoxesConfig = {
  coinsToPlay: 1,
  winRate: 1
};

export function getDefaultGameConfig(key: keyof GameConfigs) {
  if (!key) {
    throw new Error(tt("unknown_game_error", { game: key }));
  }

  switch (key) {
    case "sm":
      return DEFAULT_SM_CONFIG;

    case "fw":
      return DEFAULT_FW_CONFIG;

    case "sc":
      return DEFAULT_SC_CONFIG;

    case "dc":
      return DEFAULT_DICE_CONFIG;

    case "fc":
      return DEFAULT_FLIPCARDS_CONFIG;

    case "fk":
      return DEFAULT_FAKIR_CONFIG;

    case "mb":
      return DEFAULT_MYSTERY_BOXES_CONFIG;

    default:
      break;
  }
}
